/* sln-product-extras.js - sticky add-to-cart bar + size guide modal (product page only). */
(function () {
  var P = window.slnProduct;
  var cfg = window.slnCfg || {};
  var T = cfg.t || {};
  if (!P || !P.variants || !P.variants.length) return;

  function money(c) {
    try { return new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency || 'USD' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2); }
  }
  function resize(src, w) {
    try { var u = new URL(src, window.location.origin); u.searchParams.set('width', String(w)); return u.toString(); }
    catch (e) { return src; }
  }

  function init() {
    var form = document.querySelector('.product product-form form') || document.querySelector('product-form form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var variants = P.variants;
    var multi = variants.length > 1;
    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return variants[0];
    }
    var sel = String((idInput && idInput.value) || variants[0].id);

    /* ---- sticky bar ---- */
    var bar = document.createElement('div');
    bar.className = 'sln-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', P.title);
    bar.innerHTML = '<img alt="" width="44" height="44"><div class="sln-sticky__info"><span class="sln-sticky__title"></span><span class="sln-sticky__price"></span></div>' + (multi ? '<select></select>' : '') + '<button type="button" class="button"></button>';
    var img = bar.querySelector('img');
    var titleEl = bar.querySelector('.sln-sticky__title');
    var priceEl = bar.querySelector('.sln-sticky__price');
    var select = bar.querySelector('select');
    var btn = bar.querySelector('button');
    titleEl.textContent = P.title;

    if (select) {
      select.setAttribute('aria-label', T.variant || 'Variant');
      variants.forEach(function (v) {
        var o = document.createElement('option');
        o.value = String(v.id);
        o.textContent = v.title + (v.available ? '' : ' - ' + T.soldOut);
        o.disabled = !v.available;
        select.appendChild(o);
      });
      select.addEventListener('change', function () { sel = select.value; render(); });
    }

    function render() {
      var v = byId(sel);
      priceEl.textContent = money(v.price);
      var src = (v.featured_image && v.featured_image.src) || P.featured_image;
      if (src) { img.src = resize(src, 100); img.hidden = false; } else { img.hidden = true; }
      if (select) select.value = String(v.id);
      btn.disabled = !v.available;
      btn.textContent = v.available ? T.addToCart : T.soldOut;
    }

    btn.addEventListener('click', function () {
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var payload = { items: [{ id: parseInt(sel, 10), quantity: 1 }] };
      if (drawer) {
        payload.sections = 'cart-drawer,cart-icon-bubble';
        payload.sections_url = window.location.pathname;
      }
      fetch(cfg.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message));
          if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
            drawer.renderContents(res.data);
            render();
          } else {
            window.location.href = cfg.cartUrl;
          }
        })
        .catch(function (err) {
          btn.textContent = (err && err.message) || T.error;
          setTimeout(render, 2500);
        });
    });

    /* follow the main variant picker */
    function readMain() {
      if (idInput && idInput.value && String(idInput.value) !== String(sel)) { sel = String(idInput.value); render(); }
    }
    document.addEventListener('change', function (e) {
      if (bar.contains(e.target)) return;
      setTimeout(readMain, 350);
    });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(readMain, 50); });
      }
    } catch (e) {}

    /* show after the buy form scrolls out of view upward */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(form);
    }

    document.body.appendChild(bar);
    render();

    /* ---- size guide ---- */
    var tpl = document.getElementById('sln-sg-tpl');
    if (tpl) {
      var modal = document.createElement('div');
      modal.className = 'sln-sg';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', T.sizeGuide);
      var box = document.createElement('div');
      box.className = 'sln-sg__box';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'sln-sg__close';
      close.setAttribute('aria-label', T.close);
      close.innerHTML = '&times;';
      box.appendChild(close);
      box.appendChild(tpl.content.cloneNode(true));
      modal.appendChild(box);
      document.body.appendChild(modal);

      function closeModal() { if (window.slnModal) window.slnModal.close(modal); else modal.hidden = true; }
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('.sln-sg__close')) closeModal();
      });

      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'sln-sg-link';
      link.textContent = T.sizeGuide;
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', function () {
        if (window.slnModal) window.slnModal.open(modal); else modal.hidden = false;
      });
      var anchor = document.querySelector('.product variant-selects, .product variant-radios');
      if (anchor) anchor.insertAdjacentElement('afterend', link);
      else form.insertAdjacentElement('beforebegin', link);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();